import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import CustomeButton from "~/components/Button";
import "../shareholder-form.scss";
import useShareholderProfileAttachments from "./useShareholderProfileAttachments";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import ShareholderAttachmentTable from "./ShareholderAttachmentTable";
import Notification from "../../entities/notification/Notification";
import AdminOnly from "~/components/AdminOnly";
import { useShareHolderDetails } from "../ShareHolderDetail";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import { mergeCategories } from "~/Pages/Requests/components/new-request-modal/utils";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";
import BlobFilter from "~/components/BlobFilter";
import FilterChip from "~/components/FilterChip";

const ShareholderProfileAttachments = () => {
  const { shareholderId: id, entityId } = useParams();

  const {
    regData: { entityData },
    loading: isRegDataLoading,
  } = useShareHolderDetails();
  const {
    filesData,
    loading,
    rows,
    first,
    onPageChange,
    isDataAvailable,
    setOpenDialog,
    fileSupported,
    openDialog,
    uploadFileHandler,
    shareHolderData,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    getNameForFile,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    handleConfirmDelete,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,

    isAttachmentLoader,
    handleRestoreAttachment,
    temporaryMessage,
    setTemporaryMessage,
    restoreMessage,
    setRstoreMessage,
    role,
    selectedItems,
    filterData,
    setFilterData,
    removeFnRef,
    handleRemoveFilter,
    handleFilterChange,
    filterLoading,
    onSortOrderChange,
    onFilterApply,
    allData,
    filterPageChange,
    currentPage,
    fetchShareholderAttachments,
  } = useShareholderProfileAttachments(entityData, isRegDataLoading);

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "File Updated",
      delete: "File(s) Deleted",
    };
  };

  return (
    <Card className="gen-card shareholder__attachments">
      <div className="flex justify-content-between mb-5">
        <div>
          <p className="shareholder__attachments--heading m-0">Attachments</p>
        </div>
        <div className="inline-flex gap-2">
          <AdminOnly>
            <CustomeButton
              label="View History"
              icon="pi pi-history"
              iconPos="right"
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            />
          </AdminOnly>
          <BlobFilter
            onApply={({ value, group }) => {
              setFilterData(value);
            }}
            onRemove={(fn) => (removeFnRef.current = fn)}
            onFilterChange={({ value, grouped }) => {
              handleFilterChange(grouped);
            }}
            showEntity={false}
            showServiceLine={false}
            showYears={false}
            serviceLine={"Entities +"}
            disabled={!isDataAvailable}
          />
          <AdminOnly>
            <CustomeButton
              label="Upload File"
              icon="pi pi-upload"
              iconPos="right"
              className="upload-file-button"
              onClick={() => setOpenDialog(true)}
            />
          </AdminOnly>
        </div>
      </div>

      <FilterChip
        filterData={filterData}
        removeFilter={(id) => {
          handleRemoveFilter(id);
        }}
      />
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <div className="mt-4">
        <ShareholderAttachmentTable
          files={selectedItems.length ? allData : filesData}
          loading={selectedItems.length ? filterLoading : loading}
          first={selectedItems.length ? currentPage - 1 : first}
          rows={rows}
          onPageChange={
            selectedItems.length
              ? (e) => {
                  filterPageChange(e.page + 1);
                }
              : onPageChange
          }
          totalRecords={
            selectedItems.length ? allData.length : filesData.length
          }
          isDataAvailable={
            selectedItems.length ? allData.length : isDataAvailable
          }
          setOpenDialog={setOpenDialog}
          handleAttachmentDelete={handleDeleteDocument}
          attachmentConfirmModal={attachmentConfirmModal}
          setAttachmentConfirmModal={setAttachmentConfirmModal}
          handleConfirmDelete={handleConfirmDelete}
          onSortOrderChange={
            selectedItems?.length ? onSortOrderChange : undefined
          }
          isFilterApplied={selectedItems.length}
          onRefetch={
            selectedItems?.length ? onFilterApply : fetchShareholderAttachments
          }
        />
      </div>
      <FileUploadModal
        entitydata={shareHolderData?.entityData}
        showModal={openDialog}
        fileSupported={fileSupported}
        hideUploadModal={() => setOpenDialog(false)}
        setUploadedFile={uploadFileHandler}
        getService={getNameForFile}
        placeholder={"Choose a file to upload"}
        loading={!isFileUploaded}
        close={false}
        shareholderdata={shareHolderData}
        relatedType={"SHAREHOLDER"}
        categories={mergeCategories(["Entities +"], role)}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="SHAREHOLDERS"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default ShareholderProfileAttachments;
